// Components/Auth/ResetPassword.jsx
import React, { useEffect } from "react";
import Button from "../../Elements/Button/Button";
import Input from "../../Elements/Input/Input";
import Loader from "../../Elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import useForm from "../../../Hooks/useForm";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useIsMobile from "../../../Hooks/useIsMobile";
import * as Yup from "yup";

// 📌 Capturamos el token de la URL ANTES de inicializar el form
const params = new URLSearchParams(window.location.search);
const tokenFromUrl = params.get("token") || "";

const FORM_RESET_PASSWORD = {
  token: tokenFromUrl,
  newPassword: "",
  confirmPassword: "",
};

const FormResetPasswordScheme = Yup.object().shape({
  token: Yup.string().required("El token es obligatorio"),
  newPassword: Yup.string()
    .min(6, "La contraseña debe tener al menos 6 caracteres")
    .required("La contraseña es obligatoria"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Las contraseñas no coinciden")
    .required("Confirma tu contraseña"),
});

const ResetPassword = () => {
  const showToast = useToast();
  const {
    fetchDataResetPassword,
    loading,
    error,
    success,
    resetError,
    resetSuccess,
  } = useStore();

  const isMobile = useIsMobile();
  const bgImage = isMobile
    ? "/assets/imgs/Backgroundmob.png"
    : "/assets/imgs/Backgroundprincipal-pc.png";

  // 👀 Log inicial del token de la URL
  /*   useEffect(() => { */
  /* console.log("🔎 Token inicial de la URL:", tokenFromUrl); */
  /*   }, []); */

  useEffect(() => {
    if (error) {
      showToast("error", error);
      resetError();
    }
  }, [error, showToast, resetError]);

  useEffect(() => {
    if (success) {
      showToast("success", success.message || "Contraseña actualizada 🎉");
      resetSuccess();
      setTimeout(() => (window.location.href = "/"), 1200);
    }
  }, [success, showToast, resetSuccess]);

  const { values, errors, touched, handleBlur, handleChange, isValid } =
    useForm(FORM_RESET_PASSWORD, FormResetPasswordScheme);

  const submit = () => {
    if (!isValid) return;

    // 👀 Debug del token al enviar
    /*  console.log("🔑 Token capturado del form:", values.token); */

    fetchDataResetPassword(values.token, values.newPassword);
  };

  if (loading) return <Loader />;

  return (
    <section
      className="login-bg d-flex align-items-center min-vh-100"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100%",
      }}
    >
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div className="card glass border-0 shadow-lg overflow-hidden">
              <div className="card-body p-4 p-md-5">
                <div className="text-center mb-4">
                  <img
                    src="/assets/imgs/Sin fondo.png"
                    alt="BubUp"
                    className="login-logo mb-2"
                  />
                  <h4 className="fw-bold text-white mb-1">
                    Restablecer contraseña
                  </h4>
                  <p className="text-white-50 mb-0">
                    Ingresa tu nueva contraseña y confírmala
                  </p>
                </div>

                <form onSubmit={(e) => e.preventDefault()}>
                  {/* Campo oculto de token */}
                  <input type="hidden" value={values.token} />

                  <Input
                    value={values.newPassword}
                    label="Nueva contraseña"
                    labelColor="white"
                    variant="Password"
                    onChange={handleChange("newPassword")}
                    onBlur={handleBlur("newPassword")}
                    error={setErrorFormSimpleUtil(errors, touched, "newPassword")}
                    success={!setErrorFormSimpleUtil(errors, touched, "newPassword")}
                  />

                  <Input
                    value={values.confirmPassword}
                    label="Confirmar contraseña"
                    labelColor="white"
                    variant="Password"
                    onChange={handleChange("confirmPassword")}
                    onBlur={handleBlur("confirmPassword")}
                    error={setErrorFormSimpleUtil(errors, touched, "confirmPassword")}
                    success={!setErrorFormSimpleUtil(errors, touched, "confirmPassword")}
                  />

                  <div className="d-grid gap-2 mt-3">
                    <Button
                      text="Restablecer"
                      color="green"
                      fill
                      action={submit}
                      disabled={!isValid}
                      classNames="w-100 py-2"
                    />
                    <Button
                      text="Volver al login"
                      color="gray"
                      fill
                      action={() => (window.location.href = "/")}
                      classNames="w-100 py-2"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;